// extracted by mini-css-extract-plugin
export default {"success":"Success_success__4w4a5","fade-grow":"Success_fade-grow__OHkkC"};